import useLanguage from "../../i18n/useLanguage";
import { starvyScreens } from "../../data/products";

export default function StarvyPreview() {
  const { t } = useLanguage();
  return (
    <div className="relative isolate h-80 overflow-hidden border-b border-white/10 bg-[#123d37]">
      <div aria-hidden="true" className="absolute inset-0 opacity-20 bg-[linear-gradient(135deg,transparent_48%,rgba(255,255,255,0.12)_49%,transparent_50%)] bg-[length:48px_48px]" />
      <div className="relative z-20 pt-6 text-center">
        <p className="text-[10px] font-bold tracking-[0.25em] text-emerald-200">STARVY</p>
        <p className="mt-2 text-[27px] sm:text-[30px] font-bold leading-[1.05] tracking-tight text-white">
          {t("Catat penjualan.")}<br />
          <span className="text-[#ffde59]">{t("Atur jadwal shift.")}</span>
        </p>
      </div>
      <div aria-hidden="true" className="absolute -bottom-28 left-1/2 h-48 w-[140%] -translate-x-1/2 rounded-[50%] bg-[#ffde59]" />
      <div className="absolute inset-x-0 top-[136px] flex items-start justify-center gap-4 sm:gap-6">
        {starvyScreens.slice(0, 2).map((screen, index) => (
          <div key={screen.src} className={`w-[112px] sm:w-[124px] drop-shadow-[0_12px_14px_rgba(0,0,0,0.5)] ${index === 0 ? '-rotate-3' : 'translate-y-3 rotate-3'}`}>
            <img
              src={screen.src}
              alt={t(screen.alt)}
              width="454"
              height="960"
              loading="lazy"
              decoding="async"
              className="w-full h-auto [clip-path:inset(0_round_18%/8.5%)]"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
